import type { ButtonModifier } from '@polycups/react'
import { useMemo } from 'react'

import { ButtonLink } from '@/components/Button'

import { useLoanSimulatorProvider } from './LoanSimulatorProvider'
import { createUrlToRequestLoanFrom } from './utils'

type Props = {
  modifier?: ButtonModifier
  label: string
  rounded?: boolean
}

const LoanCta = ({ modifier = 'solid', label, rounded }: Props) => {
  const { moneyAmount, installments } = useLoanSimulatorProvider()
  const href = useMemo(
    () => createUrlToRequestLoanFrom(moneyAmount, installments),
    [moneyAmount, installments],
  )

  return (
    <ButtonLink modifier={modifier} rounded={rounded} source={href} size="lg" className="cta">
      {label}
    </ButtonLink>
  )
}

export default LoanCta
